export default "__VITE_PUBLIC_ASSET__611d1186__"